import { CHART_BUILDERS } from '../catalog/chartBuilders';
import type {
  BuildChartContext,
  ChartData,
  ChartDefinition,
  ChartResult,
} from '../catalog/types';

export function buildChartData(
  definition: ChartDefinition,
  result: ChartResult,
  ctx: BuildChartContext
): ChartData {
  const builder = CHART_BUILDERS[definition.builderKey];
  if (!builder) {
    return { values: [], labels: [] };
  }
  return builder(definition, result, ctx);
}
